export const DIMENSIONS = {
    BANNER_IMAGE: {
        WIDTH: "98px",
        HEIGHT: "64px",
    },
};
